import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EstimateMeasurementStoresService } from '../feat-estimate-measurements-v2/domain';

@Component({
    selector: 'app-estimate-measurement-search',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './estimate-measurement-search.component.html',
    styleUrls: ['../../../../../../shared/composable-styles/input.scss', '../../../../../../shared/composable-styles/button.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
})
export class EstimateMeasurementSearchComponent {
    searchInput$;
    @Output() filterChanges = new EventEmitter<string>();

    constructor(private estimateMeasurementStoresService: EstimateMeasurementStoresService) {
        this.searchInput$ = this.estimateMeasurementStoresService.searchFilter$;
    }

    onFilterChanges(event: Event) {
        const nextSearch = event ? (event.target as HTMLInputElement).value : this.searchInput$.value;
        this.searchInput$.next(nextSearch);
        this.filterChanges.emit(this.searchInput$.value);
    }

    resetFilter() {
        this.searchInput$.next('');
        this.filterChanges.emit('');
    }
}
